import React, { useContext } from 'react';
import classNames from 'classnames';
import HelmetWrapper from 'components/HelmetWrapper';
import { useTranslation } from 'react-i18next';
import DataRoomContext from '../../providers/DataRoom/DataRoom.context';
import TeamMembersTable from './components/TeamMembersTable';
import { Navigate } from 'react-router-dom';
import { getDataRoomRoute } from 'utils';
import MembersContext from '../../providers/Members/Members.context';
import { Loader } from 'ncoded-component-library';

import './BuySideTeams.styles.scss';
import './BuySideTeams.styles.responsive.scss';

type BuySideTeamsProps = {
  className?: string;
};

const BuySideTeams: React.FC<BuySideTeamsProps> = (props) => {
  const { className } = props;

  const {
    isAdmin,
    isBuySide,
    dataRoom: { _id, buySideCanInviteColleagues, name },
  } = useContext(DataRoomContext);
  const { isLoading } = useContext(MembersContext);

  const classes = classNames('buy-side-teams', 'page', className);

  const { t } = useTranslation();

  if (!isBuySide || !buySideCanInviteColleagues) {
    return (
      <Navigate
        replace
        to={getDataRoomRoute(_id, isAdmin ? 'members' : 'documents')}
      />
    );
  }

  return (
    <div className={classes}>
      <HelmetWrapper title={`${t('yourTeam')} - ${name}`} />
      <h2>{t('yourTeam')}</h2>

      {isLoading ? <Loader /> : <TeamMembersTable />}
    </div>
  );
};

export default BuySideTeams;
